import { EntidadeBase } from 'hay-core-react';
class UsuarioPinModel extends EntidadeBase {
    constructor() {
        super('usuariopin');
    }
}
const instance = new UsuarioPinModel();
export default instance;
